export const PRODUCT_IMPRESSION_INTERSECTION_THRESHOLD: number = 0.8;
export const PRODUCT_IMPRESSION_INTERSECTION_TOLERANCE: number = 0.01;
export const PRODUCT_IMPRESSION_EFFECTIVE_THRESHOLD: number = PRODUCT_IMPRESSION_INTERSECTION_THRESHOLD - PRODUCT_IMPRESSION_INTERSECTION_TOLERANCE;
export const PRODUCT_IMPRESSION_VISIBILITY_DURATION: number = 1000;
